export default __webpack_public_path__ + "static/comparisons-automl-results-763ba89ec2c6eef2ef6a9cb7132ac67d.webp";